var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-789, -6763)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0, 6401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(627, 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_facebook",
    transform: "translate(162, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56551283,1.66624741 C-0.315068752,3.61923571 0.069822282,5.69384962 0.069822282,11.9964489 C0.069822282,17.2303379 -0.843546078,22.477187 3.9366809,23.7123849 C5.42938007,24.0962034 18.655273,24.0962034 20.1459779,23.710391 C22.1362435,23.1969714 23.7555778,21.5829397 23.97694,18.7686028 C24.0078509,18.3758119 24.0078509,5.62406443 23.9759428,5.22329807 C23.7406208,2.22552583 21.8949387,0.497843994 19.4629459,0.147921129 C18.9055519,0.0671696985 18.7938737,0.0432433488 15.9341133,0.0382586926 C5.79034005,0.0432433488 3.56674678,-0.408366503 1.56551283,1.66624741 Z",
    id: "Path",
    fill: "#2D82FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25,12 L16.5,12 L16.5,9 C16.5,8.172 17.172,8.25 18,8.25 L19.5,8.25 L19.5,4.5 L16.5,4.5 L16.5,4.5 C14.0145,4.5 12,6.5145 12,9 L12,12 L9,12 L9,15.75 L12,15.75 L12,24 L16.5,24 L16.5,15.75 L18.75,15.75 L20.25,12 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.851801141214575000277eadb179e5e1.svg";
export { ForwardRef as ReactComponent };